import { ReactNode, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

interface OverlayProps {
  children: ReactNode;
}

const ReactPortalComp = (props: OverlayProps) => {
  const elRef = useRef<HTMLDivElement | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const portalRoot = document.getElementById("portal") || document.body;
    const div = document.createElement("div");
    div.setAttribute("data-portal", "true");
    portalRoot.appendChild(div);
    elRef.current = div;
    setMounted(true);

    return () => {
      portalRoot.removeChild(div);
      elRef.current = null;
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return mounted && elRef.current
    ? createPortal(<div>{props.children}</div>, elRef.current)
    : null;
};

export default ReactPortalComp;
